import { FundingFilterTypeEnum } from "src/app/shared/enums";

export const UniversalSearchModel = {
    request_type: 'COMPANIES',
    page_filters: {},
    job_title: "",
    job_title_all: "",
    job_title_any: "",
    job_title_none: "",
    company_technographic_products_bool:  [],
    company_technographic_vendors_bool:  [],
    company_technographic_sub_categories_bool:  [],
    company_technographic_products_bool_tab:  'ANY',
    company_technographic_vendors_bool_tab:  'ANY',
    company_technographic_sub_categories_bool_tab:  'ANY',
    company_technographic_products:  [],
    company_technographic_vendors:  [],
    intent_minimum_score:  null,
    intent_maximum_score:  null,
    intent_topic_threshold:  null,
    first_name:  null,
    last_name:  null,
    email:  null,
    intent_topic_ids:  [],
    si_intent_topic_ids:  [],
    lists: [],
    contact_lists: [],
    suppression_lists: [],
    rodId: [],
    match_ids: [],
    company_domains: [],
    company_names: [],
    company_ids: [],
    company_naics_codes: '',
    company_naics_codes_none: '',
    company_naics_codes_all: '',
    company_naics_codes_any: '',
    company_sic_codes: '',
    company_sic_codes_all: '',
    company_sic_codes_none: '',
    company_sic_codes_any: '',
    company_location_zipcodes: [],
    contact_location_zipcodes: [],
    company_min_size: '',
    company_max_size: '',
    company_location_zipcodes_distance: 0,
    contact_location_zipcodes_distance: 0,
    company_location_states: [],
    contact_location_states: [],
    company_location_metro: [],
    contact_location_metro: [],
    technographics: 0,
    rankings: {
        fast100: false,
        fast500: false,
        federalcontractors: false,
        forbesglobal2000: false,
        fortune500: false,
        fortune1000: false,
        fundingRoundA: false,
        fundingRoundB: false,
        fundingRoundC: false,
        fundingRoundD: false,
        fundingRoundSeed: false,
        inc5000: false,
        linkedinTopStartups2021: false,
        managedServiceProviders: false,
        publicCompanies: false,
        saas1000: false,
        valueAddedResellers: false
    },
    company_score_max: null,
    company_score_min: null,
    icpintel_job_uuid : null,
    company_technographic_categories: [],
    company_technographic_sub_categories: [],
    company_technographic_sub_categories_any: [],
    company_technographic_sub_categories_all: [],
    company_technographic_sub_categories_none: [],
    is_international: 0,
    location_country_codes: ['US'],
    company_location_hq: true,
    company_location_branch: true,
    contact_revenue_max_identifier: 'M',
    contact_revenue_min_identifier: 'M',
    job_levels: {
        brd: false,
        chf: false,
        vp: false,
        dir: false,
        mgr: false,
        stf: false/* ,
        other: false */
    },
    job_departments: {
        fnad: false,
        hr: false,
        it_is: false,
        lgl: false,
        mrkt: false,
        ops: false,
        prc: false,
        enrd: false,
        sale: false,
        other: false
    },
    job_start_date: null,
    job_sub_departments: [],
    required_fields: {
        address: false,
        phone: false,
        direct_phone: false,
        any_mobile: false,
        // personal_mobile: false,
        // work_mobile: false,
        personal_email: false,
        linkedin_url: false,
        job_title: false
    },
    tiers: 'human',
    location_types: ['hq', 'branch', 'remote', 'hqFallback'],
    gte_last_modified_date: '',
    matchOnJobHistory: true,
    page: 1,
    verified : 1,
    selected_boolean_operator: {},
    accuracy_tier_contact: '',
    accuracy_tier_company: '',
    specialties: [],
    specialties_any: [],
    specialties_all: [],
    specialties_none: [],
    popular_keywords: [],
    company_min_revenue: null,
    company_max_revenue: null,
    owned_contacts_company: {},
    owned_contacts_person: {},
    department_size: [],
    it_spend_super_category: null,
    it_spend_category: null,
    it_spend_sub_category: null,
    min_it_spend_amount: null,
    max_it_spend_amount: null,
    min_last_funding_date: null,
    max_last_funding_date: null,
    last_funding_rounds: null,
    funding_type: FundingFilterTypeEnum.TOTAL,
    min_funding_amount: null,
    min_funding_amount_identifier: 'M',
    max_funding_amount: null,
    max_funding_amount_identifier: 'M',
    last_funding_date: null,
    growth_signals: [],
    growth_signal_date: null,
    min_growth_signal_date: null,
    max_growth_signal_date: null,
    include_primary_industry_only: false,
    viDateFrom: '',
    viDateTo: '',
    viSearchDurationType: '',
    viUUID: '',
};

export type UniversalSearchModelType = typeof UniversalSearchModel;

